import { lazy } from 'react';

const PrenotazioniList = lazy(() =>  import('../pages/Reservations/List'));
const ReservationsDetail = lazy(() =>  import('../pages/Reservations/Detail'));
const PrenotazioniCreate = lazy(() =>  import('../pages/Reservations/Create'));
const ReservationsTransactions = lazy(() =>  import('../pages/Reservations/Details/Transactions/List'));
const ReservationHistory = lazy(() =>  import('../pages/Reservations/Details/History/List'));
const PrenotazioniPagamento = lazy(() =>  import('../pages/Reservations/Payment'));
const ReservationsVoucher = lazy(() =>  import('../pages/Reservations/Details/Voucher'));
const ReservationsReceipt = lazy(() =>  import('../pages/Reservations/Details/Transactions/Receipt'));

export default [{
    path: "/reservations",
    element: PrenotazioniList,
    analytics: { name: ["Prenotazioni"]},
}, {
    path: "/reservations/create",
    element: PrenotazioniCreate,
    analytics: { name: ["Prenotazioni", "Creazione"]},
}, {
    path: "/reservations/payment",
    element: PrenotazioniPagamento,
    analytics: { name: ["Prenotazioni", "Pagamento"]},
}, {
    path: "/reservations/:reservationId/info",
    element: ReservationsDetail,
    analytics: { name: ["Prenotazioni", "Dettaglio"]},
}, {
    path: "/reservations/:reservationId/voucher",
    element: ReservationsVoucher,
    analytics: { name: ["Prenotazioni", "Voucher"]},
}, {
    path: "/reservations/:reservationId/transactions",
    element: ReservationsTransactions,
    analytics: { name: ["Prenotazioni", "Ricevute"]},
}, {
    path: "/reservations/:reservationId/transactions/:transactionId/receipt",
    element: ReservationsReceipt,
    analytics: { name: ["Prenotazioni", "Ricevute", "Stampa"]},
}, {
    path: "/reservations/:reservationId/history",
    element: ReservationHistory,
    analytics: { name: ["Prenotazioni", "Storico"]},
}]
